import React from "react"
import CoreZoneLayer from "@/features/gis/CoreZoneLayer.jsx"

const rows = (p) => [
  p.name && [null, p.name],
  p.peril && ["Peril", p.peril],
  p.status && ["Status", p.status],
  p.circular && ["Circular", p.circular],
  p.as_of && ["As of", p.as_of],
  p.note && ["Note", p.note],
]

export default function Jwla(props) {
  return (
    <CoreZoneLayer
      flag="JWLA"
      path="jwla"
      title="War Risk Area (JWC)"
      style={{ fillColor: "#7b1e3c", color: "#7b1e3c", weight: 2 }}
      rows={rows}
      {...props}
    />
  )
}
